import {DictModel} from './dict.model';

export class CreateDictionaryModel extends DictModel {
  dictType: number;
  competenceType: number;
  employerBlindDictId: number;
  economySectorDictId: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dictionary/create-dict.model.ts